import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import checkForNewWindowLabels from '../../helpers/checkForNewWindowLabel';

const Checkbox = forwardRef(({
  className, label, id, itemId, newWindowLabel, ...props
}, ref) => {
  const windowLabel = checkForNewWindowLabels(newWindowLabel, label, itemId);
  return (
    <label className={cn('gcc-checkbox', className)} title={windowLabel}>
      {windowLabel}
      <input
        id={id || false}
        type="checkbox"
        className="gcc-checkbox-checkbox"
        {...props}
        ref={ref}
      />
      <span className="gcc-checkbox-checkmark" />
    </label>
  );
});

Checkbox.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  checked: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.string,
};

Checkbox.defaultProps = {
  className: [],
  checked: false,
  label: '',
  id: '',
};

export default Checkbox;
